export default __webpack_public_path__ + "static/integrationChannels-ffa348c9abdf1ebeaa91967b4f9db06d.webp";